import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingPageVehicleConfiguratorMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()
    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {String} param.data.make
   * @param {String} param.data.model
   */
  map({page, culture, data}) {
    const {make, makeId, model, modelId} = data
    const trackingData = {
      ...(make && {brand: make, brand_id: makeId}),
      ...(model && {model, model_id: modelId})
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
